import type { ClothingCategory } from '@/types/closet'

interface SizeOption {
  value: string
  label: string
  isDefault?: boolean
}

const SIZE_OPTIONS: Record<
  ClothingCategory,
  {
    options: SizeOption[]
    defaultValue: string
  }
> = {
  footwear: {
    options: [
      { value: '7', label: 'US 7' },
      { value: '7.5', label: 'US 7.5' },
      { value: '8', label: 'US 8' },
      { value: '8.5', label: 'US 8.5' },
      { value: '9', label: 'US 9' },
      { value: '9.5', label: 'US 9.5' },
      { value: '10', label: 'US 10' },
      { value: '10.5', label: 'US 10.5' },
      { value: '11', label: 'US 11' },
      { value: '11.5', label: 'US 11.5' },
      { value: '12', label: 'US 12' },
    ],
    defaultValue: '10',
  },
  bottoms: {
    options: [
      { value: '28x30', label: '28x30' },
      { value: '29x30', label: '29x30' },
      { value: '30x30', label: '30x30' },
      { value: '30x32', label: '30x32' },
      { value: '31x32', label: '31x32' },
      { value: '32x32', label: '32x32' },
      { value: '32x34', label: '32x34' },
      { value: 'XS', label: 'XS' },
      { value: 'S', label: 'S' },
      { value: 'M', label: 'M' },
      { value: 'L', label: 'L' },
      { value: 'XL', label: 'XL' },
    ],
    defaultValue: '30x32',
  },
  tops: {
    options: [
      { value: 'XS', label: 'XS' },
      { value: 'S', label: 'S' },
      { value: 'M', label: 'M' },
      { value: 'L', label: 'L' },
      { value: 'XL', label: 'XL' },
      { value: 'XXL', label: 'XXL' },
    ],
    defaultValue: 'M',
  },
  outerwear: {
    options: [
      { value: 'XS', label: 'XS' },
      { value: 'S', label: 'S' },
      { value: 'M', label: 'M' },
      { value: 'L', label: 'L' },
      { value: 'XL', label: 'XL' },
      { value: 'XXL', label: 'XXL' },
    ],
    defaultValue: 'M',
  },
  accessories: {
    options: [
      { value: 'OS', label: 'One Size' },
      { value: 'S', label: 'S' },
      { value: 'M', label: 'M' },
      { value: 'L', label: 'L' },
    ],
    defaultValue: 'OS',
  },
  headwear: {
    options: [
      { value: 'OS', label: 'One Size' },
      { value: 'S/M', label: 'S/M' },
      { value: 'L/XL', label: 'L/XL' },
    ],
    defaultValue: 'OS',
  },
  underwear: {
    options: [
      { value: 'XS', label: 'XS' },
      { value: 'S', label: 'S' },
      { value: 'M', label: 'M' },
      { value: 'L', label: 'L' },
      { value: 'XL', label: 'XL' },
    ],
    defaultValue: 'M',
  },
  fullbody: {
    options: [
      { value: 'XS', label: 'XS' },
      { value: 'S', label: 'S' },
      { value: 'M', label: 'M' },
      { value: 'L', label: 'L' },
      { value: 'XL', label: 'XL' },
    ],
    defaultValue: 'M',
  },
  fragrances: {
    options: [
      { value: '30ml', label: '30ml / 1oz' },
      { value: '50ml', label: '50ml / 1.7oz' },
      { value: '75ml', label: '75ml / 2.5oz' },
      { value: '100ml', label: '100ml / 3.4oz' },
      { value: '125ml', label: '125ml / 4.2oz' },
      { value: '200ml', label: '200ml / 6.8oz' },
    ],
    defaultValue: '100ml',
  },
}

export function getSizeOptions(category: ClothingCategory) {
  return SIZE_OPTIONS[category] || SIZE_OPTIONS.tops
}
